import fingerprint from "fingerprintjs2";
import jsonp from "jsonp";
import parser from "ua-parser-js";

const objToAjaxParams = (data = {}) => {
  let txtArr = [];
  for (let key in data) {
    txtArr.push(`${key}=${data[key]}`);
  }
  txtArr.push("callback");
  return txtArr.join("&");
};

const getNewId = function () {
  return `${(+new Date() + Math.floor(Math.random() * 999999))
    .toString(36)
    .toUpperCase()
    .slice(4)}`;
};

// 防止和正常业务的jsonp的callback命名重复；防止脚本加载多次导致命名重复
let jsonFnCount = 0;
let JSON_FN_TXT = getNewId();

export const sleep = (time = 1) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(void 0);
    }, time * 1000);
  });
};

export const getJSON = (url, data = {}) => {
  return new Promise((resolve) => {
    jsonFnCount++;
    jsonp(
      url,
      {
        param: objToAjaxParams(data),
        prefix: "jsonpCallback",
        name: `hwpfn_${JSON_FN_TXT}_${jsonFnCount}`,
      },
      (_err, res) => {
        resolve(res);
      }
    );
  });
};

export const getAjaxLink = (url, data) => {
  let res = url;
  if (~url.indexOf("?")) {
    res += "&";
  } else {
    res += "?";
  }
  for (let key in data) {
    res += `${key}=${encodeURIComponent(String(data[key]))}&`;
  }
  return res;
};

export const getUrlParams = (name) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let r = window.location.search.substring(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return "";
};

export const getGameId = () => {
  return (
    getUrlParams("gameId") || getUrlParams("gameID") || getUrlParams("game_id")
  );
};

export const getSystemLanguage = function () {
  let res = navigator.language;
  if (~res.indexOf("-")) {
    const langArr = res.split("-");
    res = langArr[0] === "zh" ? langArr[1] : langArr[0];
  }
  return res.toLowerCase();
};

export const createFingerPrint = async (data = {}) => {
  return new Promise((resolve) => {
    fingerprint.get((components) => {
      // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
      let values = components.map((component) => component.value); // 配置的值的数组
      for (let i in data) {
        values.push(data[i]);
      }
      const murmur = fingerprint.x64hash128(values.join(""), 31); // 生成浏览器指纹
      resolve(murmur);
    });
  });
};

export const getDevice = () => {
  let userAgent = window.navigator.userAgent;
  let ua = userAgent.toLowerCase();
  return {
    isAndroid: function () {
      return ua.indexOf("android") > -1;
    },
    isIOS: function () {
      let NPlatform = navigator?.platform;
      return (
        ua.indexOf("iphone") > -1 ||
        /iPad|iPhone|iPod/gi.test(NPlatform) ||
        (NPlatform === "MacIntel" &&
          navigator.maxTouchPoints > 1 &&
          !window.MSStream)
      );
    },
    isWinPhone: function () {
      return !!navigator.userAgent.match(/Windows Phone/i);
    },
    isIpad: function () {
      return ua.indexOf("ipad") > -1;
    },
    isPhone: function () {
      return (
        this.isAndroid() || this.isIOS() || this.isWinPhone() || this.isIpad()
      );
    },
  };
};

export const getPlatform = () => {
  if (getMainHost() === "gm99.com") {
    return "gm99";
  }
  return "global";
};

export const getMainHost = () => {
  return window.location.host.match(/\w+\.(com|vn|hk)/)[0];
};

const getSystemInfo = () => {
  if (getDevice().isAndroid() || getDevice().isWinPhone()) {
    return "android";
  }
  if (getDevice().isIOS() || getDevice().isIpad()) {
    return "ios";
  }
  return "pc";
};

export const systemInfo = getSystemInfo();

export const deviceInfo = getDevice().isPhone() ? "mobile" : "pc";

const browserInfo = parser();

export const getBrowserVerson = () => {
  return browserInfo.browser.version || "";
};

export const getBrowserName = () => {
  return browserInfo.browser.name || "";
};

export const getBrowserType = () => {
  return browserInfo.device.type || "pc";
};

export const getOsVersion = () => {
  return browserInfo?.os?.version || "";
};

export const getOsModel = () => {
  return browserInfo?.device?.model || "";
};

export const canUseProxy = () => {
  return Object.prototype.toString.call(window.Proxy) == "[object Function]";
};
